export const locale = {
    lang: 'pt',
    data: {
      'FILEMANAGER': {
        'TITULO': 'Gestor de ficheiros',
        'SUBTI': 'Carregue ficheiros relevantes para o seu negócio.',
        'GPTW': {
          'TITULO': 'Seleccione uma empresa para ver a lista de ficheiros carregados',
          'NUMFILES': 'Número de ficheiros: '
        },
        'CT_NAME':'Empregados que sofreram um acontecimento traumático grave',
        'LABEL01':'Locais de trabalho',
        'CARGA': {
          'TITULO': 'Clique aqui para fazer upload de um arquivo ou arraste e solte aqui',
          'CARGANDOTIT': 'Carregamento...',
          'CARGANTOTXT': 'O ficheiro está a ser enviado para a base de dados. Por favor, aguarde.'
        },
        'MENU': {
          'BOTON': 'Novo',
          'ARCHIVO': 'Arquivo',
          'CARPETA': 'Pasta',
          'EXCELTI': 'Baixe o Excel TI'
        },
        'LISTA': {
          'TITULOS': {
            'NOMBRE': 'Nome',
            'EXTEN': 'Extensão',
            'FECHA': 'Data de carregamento',
            'ACCIONES': 'Acções',
            'TAMANIO': 'Tamanho'
          },
          // Temporales
          'TITULOSENC':{
            'NOMBRE': 'Nome do contribuinte: ',
            'ARCH': 'Nome do ficheiro',
            'DATE': 'Data de carregamento',
            'EXTEN': 'Nome do centro de trabalho: ',
            'ACT':'Acções',
            'BT':'Início'
          },
          'TOOLTIP': {
            'DESCARGA': 'Descarregar este ficheiro',
            'DELETE': 'Apagar este ficheiro',
            'OPENFOLDER': 'Clique aqui para abrir esta pasta',
            'VACIO': 'Esta pasta está vazia'
          }
        },
        'MENSAJES': {
          'CARGAOK': 'O ficheiro foi armazenado correctamente.',
          'CARGAREP': 'Este ficheiro não pôde ser carregado. Já existe um ficheiro com o mesmo nome.',
          'DELETERLY': 'Confirmar para apagar este ficheiro?',
          'DELETEOK': 'O ficheiro foi apagado com sucesso.',
          'CREATEFOLDER': 'Introduza o nome para a nova pasta',
          'FOLDEROK': 'A pasta foi criada correctamente.',
          'archivo_save_4': 'Esta pasta não pôde ser criada. Já existe uma pasta com o mesmo nome.',
          'DELETEFOLDERRLY': 'Confirma para apagar esta pasta?\n\nAtenção: O conteúdo desta pasta será também eliminado',
          'DELETEFOLDEROK': 'A pasta, juntamente com o seu conteúdo, foi apagada com sucesso.',
          'INVALID_CHARS': 'O nome da pasta só pode conter caracteres da letra A a Z e números',
          'BOTONES': {
            'SI': 'Sim',
            'NO': 'Não',
            'ACEPTAR': 'Aceitar',
            'CREAR': 'Criar',
            'CANCELAR': 'Cancelar'
          }
        },
        'CARPETASDEFAULT':{
          'Información TI': 'Informação IT',
          'Información CA': 'Informação CA',
          'Información General': 'Informação geral',
          'Comunicación NOM-035': 'Comunicação NOM-035',
          'Listado de colaboradores NOM-035': 'Lista de colaboradores NOM-035',
          'PDF de resultados NOM-035':'PDF de resultados NOM-035',
          'Campaña de Comunicación 2020': 'Campanha de Comunicação',
          // 'Culture Audit': 'Culture Audit',
          'Guía de certificación': 'Guia de Certificação',
          'Listado de colaboradores': 'Lista de colaboradores',
          'Plantillas': 'Modelos',
          'Templates con TI': 'Modelos com TI',
          'Templates Página': 'Página de modelos',
          'Certificar': 'Certificar',
          'Focus Area': 'Focus Area',
          'Medir': 'Medida',
          'Pulsecheck': 'Pulsecheck',
          'Row Data': 'Row Data',
          'Reports': 'Relatórios',

          'Campana de Comunicacion': 'Campanha de comunicação',
          'Culture Audit': 'Auditoria de Cultura™',
          'Great Book': 'Grande livro',
          'Cuestionarios': 'Questionários',
          'Pulse Check': 'Pressione Verificar',
          'Base de datos': 'Base de dados',
          'Practicas For All': 'Estágios para todos',
          'Reporte de Resultados': 'Relatório de resultados',
          'Validacion': 'Validação',
        }
      }
    }
};
